var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"kus-content--container",attrs:{"flat":"","max-width":"800","loading":_vm.loading}},[_c('v-card-title',[_vm._v(_vm._s(_vm.content.title))]),_c('v-card-text',[_c('div',{directives:[{name:"marked",rawName:"v-marked",value:(_vm.content.body),expression:"content.body"}],staticClass:"kus-content"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }